import { render, staticRenderFns } from "./orgRole.vue?vue&type=template&id=1e349df8&"
import script from "./orgRole.vue?vue&type=script&lang=js&"
export * from "./orgRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports